import React, { useState, useEffect } from 'react';
import { EuiFlexGroup, EuiFlexItem, EuiLoadingContent, EuiPanel } from '@elastic/eui';
import * as types from '../../reduxStore/types/orders';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { getAbandonedOrders } from '../../api/abandonedOrders/getAbandonedOrders';
import LiveOrdersTableForPast from '../liveOrders/liveOrdersTableForPast';
import LiveOrderDetailsForPast from '../liveOrders/liveOrderDetailsPastOrders';
import '../liveOrders/style.css';
import CustomDatePicker from '../Credits/CustomDatePicker';

const AbandonedCartComponent = () => {
    const [startDateTime, setStartDateTime] = useState(moment());
    const [endDateTime, setEndDateTime] = useState(moment());
    const [state, setState] = useState({
        apiDataLoaded: false,
        last_page: 0,
        current_page: 0,
        loaderPage: false,
        totalCounts: 0,
        page_size: 10,
    });
    const abandonedCarts = useSelector((state) => state.orders.abandonedCarts);
    const selectedOrderId = useSelector((state) => state.orders.selectedOrderId);
    const currentOrderingMode = useSelector((state) => state.orders.currentOrderingMode);
    const dispatch = useDispatch();
    const selectedOutletId = useSelector((state) => state.outlet.selectedOutletId);

    useEffect(() => {
        if (selectedOutletId) {
            dispatch(getAbandonedOrders(startDateTime, endDateTime, state, currentOrderingMode));
        }
    }, [currentOrderingMode, dispatch, endDateTime, selectedOutletId, startDateTime]);

    const filteredOrder = abandonedCarts.filter((data) => data.cart_id === selectedOrderId);

    useEffect(() => {
        (() => {
            if (filteredOrder.length < 1 && abandonedCarts.length > 0) {
                dispatch({
                    type: types.SET_SELECTED_ORDER,
                    payload: abandonedCarts[0].cart_id,
                });
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filteredOrder]);

    return (
        <div>
            <EuiFlexGroup direction='row' style={{ width: '100%' }}>
                <EuiFlexItem grow={false} style={{ width: '80%' }}>
                    <CustomDatePicker
                        startDate={startDateTime}
                        setStartDate={setStartDateTime}
                        endDate={endDateTime}
                        setEndDate={setEndDateTime}
                        displayFormat='DD-MM-YYYY'
                    />
                </EuiFlexItem>
            </EuiFlexGroup>
            {selectedOutletId ? (
                <>
                    <EuiFlexGroup>
                        <EuiFlexItem grow={6}>
                            <EuiPanel paddingSize='s' className='abandonedOrderPanel scrollbar-sm'>
                                <LiveOrdersTableForPast
                                    startDateTime={startDateTime}
                                    endDateTime={endDateTime}
                                    state={state}
                                    setState={setState}
                                    isAbandoned={true}
                                />
                            </EuiPanel>
                        </EuiFlexItem>
                        <EuiFlexItem grow={4}>
                            <EuiPanel paddingSize='s' className='abandonedOrderPanel scrollbar-sm'>
                                <LiveOrderDetailsForPast isAbandoned={true} />
                            </EuiPanel>
                        </EuiFlexItem>
                    </EuiFlexGroup>
                </>
            ) : (
                <EuiLoadingContent lines={10} />
            )}
        </div>
    );
};

export default AbandonedCartComponent;
